

export const getNomineeCardCounts = async (userId: number, isUserSubmissions: boolean) => {

	try {
		

		let response = await fetch(`api/NomineeDashboard/CardCounts?userId=${userId}&isUserSubmissions=${isUserSubmissions}`);

		if (!response.ok)
			throw new Error("Failed to get nominee card counts.");

		return response.json();

	} catch (error) {
		console.error(error);
		throw error;
	}
};